import { ApplicationState } from "../types";

export const selectIsAuthenticated = (store: ApplicationState): undefined | boolean => store.session?.isAuthenticated;
export const selectToken = (store: ApplicationState): undefined | string => store.session?.token;
